import { RouteRecordRaw } from 'vue-router';
import { dataleverancier, systeembeheerder } from '@/core/security/roleTypes';
import Publications from './Publications.vue';
import PublicationDetail from './PublicationDetail.vue';
import PublicationVersionDetail from './PublicationVersionDetail.vue';
import PublicationCreate from './PublicationCreate.vue';

export const publicationsRoutes: RouteRecordRaw = {
    path: '/publications',
    meta: {
        hasRoles: [dataleverancier, systeembeheerder],
        feature: 'publications'
    },
    children: [
        {
            path: '',
            name: 'publications',
            component: Publications,
            meta: {
                hasRoles: [dataleverancier, systeembeheerder]
            }
        },
        {
            path: '/publication/:id',
            name: 'publication.detail',
            component: PublicationDetail,
            meta: {
                hasRoles: [dataleverancier, systeembeheerder]
            }
        },
        {
            path: '/publication/:id/version/:versionId',
            name: 'publication.version.detail',
            component: PublicationVersionDetail,
            meta: {
                hasRoles: [dataleverancier, systeembeheerder]
            }
        },
        {
            path: '/publication/:id/create',
            name: 'publication.create',
            component: PublicationCreate,
            meta: {
                hasRoles: [dataleverancier, systeembeheerder]
            }
        }
    ]
};
